export enum ERROR_CODE {
    EMAIL_DOMAIN_NOT_FOUND = 'email_domain_not_found',
    MEMBER_INACTIVE = 'member_inactive',
    MEMBER_ACTIVE_IN_FUTURE = 'member_active_in_future',
}
